/* @flow */

export const CLASS = {
    CONTAINER: 'paypal-button-container',
    BUTTON:    'paypal-button',

    LABEL:      'paypal-button-label',
    COLOR:      'paypal-button-color',
    LOGO_COLOR: 'paypal-button-logo-color',
    SHAPE:      'paypal-button-shape',
    BRANDING:   'paypal-button-branding',
    LAYOUT:     'paypal-button-layout',
    NUMBER:     'paypal-button-number',
    ENV:        'paypal-button-env',

    TAGLINE:       'paypal-button-tagline',
    TAGLINE_COLOR: 'paypal-button-tagline-color',
    FUNDINGICONS:  'paypal-button-fundingicons',

    TEXT: 'paypal-button-text',
    LOGO: 'paypal-button-logo',
    CARD: 'paypal-button-card',

    SEPARATOR: 'paypal-separator'
};



// WEBPACK FOOTER //
// ./src/components/button/templates/component/style/class.js